<template>
    <div v-if="availableTags.length" class="tags-filter">
        <label class="provider-label">Filter by provider:</label>
        <div class="tags-list">
            <span v-for="tag in availableTags" :key="tag" @click="handleToggleTag(tag)">
                <c-badge :text="tag" class="tag-filter" pill :class="{ active: selectedTags.includes(tag) }" />
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import store from '@/store';
import { PresetTag } from '@/components/DesignStudio/ImageEffectsProperties/types/presets';
import CBadge from '@/components/shared/CBadge';

const availableTags = computed(() => store.getters['imageEffectsProperties/availableTags']);
const selectedTags = computed(() => store.getters['imageEffectsProperties/selectedTags']);

const handleToggleTag = (tag: PresetTag) => {
    store.dispatch('imageEffectsProperties/toggleTag', tag);
};
</script>

<style scoped lang="scss">
.tags-filter {
    .provider-label {
        font-size: 14px;
        font-weight: 500;
        color: var(--gray-dark);
        margin-bottom: 8px;
        display: block;
    }

    .tags-list {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
    }

    .tag-filter {
        padding: 6px 8px;
        cursor: pointer;

        &:hover {
            border-color: var(--primary-purple);
            color: var(--primary-purple);
        }

        &.active {
            background: var(--primary-purple);
            color: white !important;
            border-color: var(--primary-purple);
        }
    }
}
</style>
